<template>
  <div>
    <modal-container
      v-if="modelValue"
      :iconColor="'#29C4D0'"
      :icon="'mdi-cloud-download'"
      :gap="'30px'"
      :borderRadius="'20px'"
      :padding="'40px'"
      title='הפקת דו"ח חשבונות פתוחים ללקוח'
    >
      <Backdrop @close-model="closeModal" :bgColor="'#00000061'"></Backdrop>

      <div v-if="false" class="date-filters">
        <datePickerButton
          :header="' מתאריך'"
          :width="'150px'"
          @openModal="openDatePicker('fromDate')"
        >
          <div>
            <v-text-field
              class="flex-1-0 date-picker pr-2"
              hide-details="auto"
              prepend-inner-icon="mdi-calendar-end"
              :model-value="formattedDate(fromDate, 'מתאריך')"
              variant="plain"
              style="pointer-events: none"
            ></v-text-field>
          </div>
        </datePickerButton>
        <datePickerButton
          :header="'עד תאריך'"
          :width="'150px'"
          @openModal="openDatePicker('toDate')"
        >
          <div>
            <v-text-field
              class="flex-1-0 date-picker pr-2"
              hide-details="auto"
              prepend-inner-icon="mdi-calendar-end"
              :model-value="formattedDate(toDate, 'עד תאריך')"
              variant="plain"
              style="pointer-events: none"
            ></v-text-field>
          </div>
        </datePickerButton>
      </div>
      <v-btn
        @click="downloadFile"
        width="145"
        height="55"
        rounded="xl"
        class="download-btn"
        color="#35BAE0"
      >
        <span> הפקת הדו"ח</span>
      </v-btn>
    </modal-container>
    <datePickerModal
      @update:modelValue="updateDownloadDate"
      @trigger-date-picker-update="updateDownloadDate"
      :openModal="openModalDatePicker"
    />
  </div>
</template>

<script>
import ModalContainer from "@/components/UI/modals/modal-container.vue";
import Backdrop from "@/components/UI/backdrop.vue";
import datePickerButton from "@/components/UI/datePickerButton.vue";
import datePickerModal from "@/components/UI/modals/datePickerModal.vue";
import { dateToDisplay } from "@/dates";
import moment from "moment";

export default {
  components: {
    ModalContainer,
    Backdrop,
    datePickerButton,
    datePickerModal,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      openModalDatePicker: false,
      ModalDatePickerType: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("update:modelValue", false);
    },
    openDatePicker(type) {
      this.openModalDatePicker = true;
      this.ModalDatePickerType = type;
    },
    updateDownloadDate(date) {
      this.openModalDatePicker = false;
      if (this.ModalDatePickerType === "fromDate") {
        this.fromDate = moment(date).toDate();
      } else {
        this.toDate = moment(date).toDate();
      }
    },
    formattedDate(date, text) {
      if (!date) return text;
      return dateToDisplay(date);
    },
    downloadFile() {
      this.$emit("download", { fromDate: this.fromDate, toDate: this.toDate });
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.date-filters {
  display: flex;
  gap: 40px;
}

.download-btn {
  font-size: $smallTextSize;
  font-weight: 400;
  color: white !important;
}
</style>
